"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlickSlider = void 0;
const react_1 = __importStar(require("react"));
const react_slick_1 = __importDefault(require("react-slick"));
const styled_1 = require("./styled");
const navigation_bar_1 = require("./navigation-bar");
const components_core_1 = require("@volkswagen-onehub/components-core");
const __1 = require("..");
const typing_1 = require("../text-custom/typing");
const is_browser_1 = __importDefault(require("is-browser"));
const helpers_1 = require("../helpers");
const getVisibleTabCount = (desktop, tablet) => {
    if (!is_browser_1.default)
        return desktop;
    const isDesktopViewport = window.matchMedia(`(min-width: ${helpers_1.Breakpoints.b960}px)`).matches;
    const isTabletViewport = window.matchMedia(`(min-width: ${helpers_1.Breakpoints.b560}px)`).matches;
    if (isDesktopViewport) {
        return desktop;
    }
    else if (isTabletViewport) {
        return tablet;
    }
    else {
        return 1; //Mobile
    }
};
const isDivisible = (slides, slidesToShow) => {
    let number = slides;
    while (number % slidesToShow !== 0) {
        number++;
    }
    return number - slides;
};
const createGhostSlides = (ghostSlides) => {
    let result = Array();
    if (!is_browser_1.default || (window && window.innerWidth > 560)) {
        for (let i = 0; i <= ghostSlides; i++) {
            result.push(react_1.default.createElement(styled_1.GhostSlider, { key: 'ghost-slide-' + i }));
        }
    }
    return result;
};
const SlickSlider = (props) => {
    const { visibleCards, visibleCardOnTablet, children, slickSettings, showArrows, showElementNumber, showElementPagination, scroll1by1, hideMargin, showBorder, hideArrowsMobile, onActionTrackingTrigger, } = props;
    const [mainSlider, setSlider] = (0, react_1.useState)();
    const [currentSlide, setCurrentSlide] = (0, react_1.useState)(1);
    const [disablePrev, setDisabledPrev] = (0, react_1.useState)(true);
    const [disableNext, setDisabledNext] = (0, react_1.useState)(false);
    const [visibleTabCount, setVisibleTabCount] = (0, react_1.useState)(getVisibleTabCount(visibleCards, visibleCardOnTablet));
    const [lastSlideShowing, setLastSlideShowing] = (0, react_1.useState)(currentSlide + Math.floor(visibleTabCount) - 1);
    const [ghostSlides, setGhostSlides] = (0, react_1.useState)(isDivisible(children.length, Math.floor(visibleTabCount)));
    const [ghostSlidesResult, setGhostSlidesResult] = (0, react_1.useState)(createGhostSlides(ghostSlides));
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [totalPages, setTotalPages] = (0, react_1.useState)(Math.ceil(children.length / Math.floor(visibleTabCount)));
    const showGhostSlides = scroll1by1 ? false : true;
    const [deleteOpacity, setDeleteOpacity] = (0, react_1.useState)(false);
    const [arrowsClicked, setArrowsClicked] = (0, react_1.useState)(false);
    const sliderSettings = Object.assign({ arrows: false, infinite: false, slidesToShow: visibleCards, slidesToScroll: scroll1by1 ? 1 : Math.floor(visibleCards), speed: 500, afterChange: (current) => afterSlideChange(current + 1), responsive: [
            {
                breakpoint: helpers_1.Breakpoints.b960, //Tablet
                settings: {
                    slidesToShow: visibleCardOnTablet,
                    slidesToScroll: scroll1by1 ? 1 : Math.floor(visibleCardOnTablet),
                },
            },
            {
                breakpoint: helpers_1.Breakpoints.b560, //Mobile
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ] }, slickSettings);
    //If showElementPagination is true, show pagination
    const getPaginationString = (isMobile) => {
        return (react_1.default.createElement(__1.TextCustom, { appearance: components_core_1.TokenTextAppearance.headline200, style: {
                fontSize: typing_1.TextSize.TextSize16,
                lineHeight: typing_1.TextLineHeight.TextLineHeight20,
            } },
            isMobile ? '' : 'Page ',
            react_1.default.createElement(__1.TextCustom, { style: { fontWeight: typing_1.TextWeight.bold } }, isMobile ? `${currentSlide}` : `${currentPage}`),
            isMobile ? ` of ${children.length}` : ` of ${totalPages}`));
    };
    //If showElementNumber is true, show counter
    const getPageNumberString = (isMobile) => {
        return (react_1.default.createElement(__1.TextCustom, { appearance: components_core_1.TokenTextAppearance.headline200, style: {
                fontSize: typing_1.TextSize.TextSize16,
                lineHeight: typing_1.TextLineHeight.TextLineHeight20,
            } },
            react_1.default.createElement(__1.TextCustom, { style: { fontWeight: typing_1.TextWeight.bold } }, isMobile ? `${currentSlide}` : `${currentSlide}-${lastSlideShowing}`),
            ` of ${children.length}`));
    };
    const getInformationString = () => {
        if (!is_browser_1.default)
            return undefined;
        const isMobileView = window.matchMedia(`(max-width: ${helpers_1.Breakpoints.b560}px)`)
            .matches;
        if (showElementNumber) {
            return getPageNumberString(isMobileView);
        }
        else if (showElementPagination) {
            return getPaginationString(isMobileView);
        }
        else {
            return undefined;
        }
    };
    const next = () => {
        setDeleteOpacity(true);
        setArrowsClicked(true);
        mainSlider.slickNext();
    };
    const previous = () => {
        setArrowsClicked(true);
        mainSlider.slickPrev();
    };
    const manageArrows = () => {
        setDisabledPrev(false);
        setDisabledNext(false);
        let islastSlide = currentSlide + (visibleTabCount - 1);
        if (islastSlide >= children.length || visibleTabCount > children.length) {
            setDisabledNext(true);
        }
        if (currentSlide === 1) {
            setDisabledPrev(true);
        }
    };
    const afterSlideChange = (current) => {
        setCurrentSlide(Math.floor(current));
        onActionTrackingTrigger &&
            onActionTrackingTrigger(arrowsClicked ? 'click' : 'swipe', currentSlide > current ? 'previous' : 'next');
        setArrowsClicked(false);
    };
    const handleResize = () => {
        setVisibleTabCount(getVisibleTabCount(visibleCards, visibleCardOnTablet));
    };
    const isElementOpacity = (index) => lastSlideShowing === index;
    const handleResizeGhostSlides = () => {
        if (showGhostSlides) {
            let ghost_slides = isDivisible(children.length, Math.floor(visibleTabCount));
            setGhostSlides(ghost_slides);
            setGhostSlidesResult(createGhostSlides(ghost_slides));
        }
    };
    const handleLastSlide = () => {
        let islastSlide = currentSlide + (visibleTabCount - 1);
        if (islastSlide >= children.length) {
            setLastSlideShowing(children.length);
        }
        else {
            setLastSlideShowing(currentSlide + Math.floor(visibleTabCount) - 1);
        }
    };
    const handleTotalPagination = () => {
        setTotalPages(Math.ceil(children.length / Math.floor(visibleTabCount)));
    };
    const handlePagination = () => {
        setCurrentPage(Math.ceil(currentSlide / Math.floor(visibleTabCount)));
    };
    //When click next-prev or scroll slider
    (0, react_1.useEffect)(() => {
        handleLastSlide();
        manageArrows();
        handlePagination();
        setDeleteOpacity(false);
    }, [currentSlide]);
    //When a window resize is made or a zip code is made
    (0, react_1.useEffect)(() => {
        handleResizeGhostSlides();
        handleLastSlide();
        manageArrows();
        handlePagination();
        handleTotalPagination();
    }, [visibleTabCount, children]);
    (0, react_1.useEffect)(() => {
        if (is_browser_1.default) {
            window.addEventListener('resize', handleResize);
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("link", { rel: "stylesheet", type: "text/css", charSet: "UTF-8", href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" }),
        react_1.default.createElement("link", { rel: "stylesheet", type: "text/css", href: "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" }),
        showArrows && (react_1.default.createElement(styled_1.StylePaginationBarWrapper, { showBorder: showBorder, className: "slick-pagination-bar" },
            react_1.default.createElement(navigation_bar_1.NavigationBar, { clickPrev: previous, clickNext: next, disabledNext: disableNext, disabledPrev: disablePrev, pageNumber: getInformationString(), hideArrowsMobile: hideArrowsMobile }))),
        react_1.default.createElement("div", { className: "slick-carousel" },
            react_1.default.createElement(styled_1.StyledCarouselWrapper, { hideMargin: hideMargin },
                react_1.default.createElement(react_slick_1.default, Object.assign({}, sliderSettings, { ref: (slider) => setSlider(slider) }),
                    children.map((child, index) => (react_1.default.createElement(styled_1.StyledContainer, { key: `${child.key}`, hideMargin: hideMargin }, react_1.default.cloneElement(child, {
                        opacity: deleteOpacity ? false : isElementOpacity(index),
                    })))),
                    showGhostSlides && ghostSlidesResult)))));
};
exports.SlickSlider = SlickSlider;
{
    /*
      HOW USE THIS COMPONENT
      <SlickSlider
        visibleCards={3.5}
        visibleCardOnTablet={2.5}
        showArrows={true} //optional: enable arrows to navigate the slider
        slickSettings={sliderSettings} //optional: slick settings for a different specifications
        showElementNumber //optional: shows the current active slides and the number of slides available
        scroll1by1 //optional: enable scroll to 1, the default is the Math.floor(visibleCards/visibleCardOnTablet)
        showElementPagination //optional: shows the current page and the number of pages available
        showBorder //optional: add bottom border on Navigation Bar
        hideArrowsMobile //optional: hide arrow only for mobile
      />
    */
}
